'use strict';

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    method: [options are 'scroll', 'click']
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */
  var defaultSettings = {
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    container: '#AjaxinateLoop',
    offset: 0,
    loadingText: 'Loading',
     callback: function() {
    document.dispatchEvent(new CustomEvent('ajaxinate:loaded'));
  }
  };
  // Merge configs
  this.settings = Object.assign(defaultSettings, settings);

  // Bind 'this' to applicable prototype functions
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);

  // Set up our element selectors
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  // Find and initialise the correct function based on the method set in the config
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners,
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];

      if (newContainer.querySelector('.promo-list')) {
        newContainer.querySelectorAll('.promo-list').forEach((promoLi) => {
          promoLi.classList.add('hidden');
        });
      }

      const searchInput = document.querySelector('.collection-main-right input[type="search"]');
      if (searchInput) {
        const gridLiLength =
          document.querySelectorAll('.collection-main-right #product-grid li[data-title]').length || 1;
        const gridLiHiddenLength =
          document.querySelectorAll('.collection-main-right #product-grid li[data-title].hidden').length || 0;
        let triggerScroll = false;
        if (gridLiHiddenLength == gridLiLength) {
          triggerScroll = true;
        } else {
          triggerScroll = false;
        }
        window.collectionProductSearch(newContainer, searchInput.value, triggerScroll);
      }
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;
      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }
      this.initialize();
      if (window.themeSettings && window.themeSettings.showSubscriptionToggle) {
        let datasubscriptionvalue = document.querySelector('.data-subscription-value');
        let getsubscription = datasubscriptionvalue?.getAttribute('data-subscription');

        let productForm = document.querySelectorAll('form[action="/cart/add"][data-stock="in-stock"]');
        let buttonShop = document.querySelectorAll('.product-form__cart-submit');
        if (getsubscription == 'true') {
          productForm.forEach((form) => {
            form.setAttribute('data-recharge-loaded', 'true');
            form.setAttribute('data-skio-loaded', 'true');
            form.setAttribute('data-onetime', 'true');
            applyRechargeProductWidget();
          });
          if (window.innerWidth < 749) {
            buttonShop.forEach((button) => {
              const spanText = button.querySelector('span');
              if (spanText) spanText.textContent = 'Subscribe';
            });
          }
        } else {
          productForm.forEach((form) => {
            form.setAttribute('data-recharge-loaded', 'false');
            form.setAttribute('data-skio-loaded', 'false');
            form.setAttribute('data-onetime', 'false');
          });
          buttonShop.forEach((button) => {
            const spanText = button.querySelector('span');
            if (spanText) spanText.textContent = 'Add to cart';
          });
        }
      } else {
        applyRechargeProductWidget();
      }

      setTimeout(function () {
        const collectionItems = document.querySelectorAll('#product-grid .grid__item');

        collectionItems.forEach((item) => {
          const percentageElement = item.querySelector('span.rc-option__discount.rc_widget__option__discount');
          const discountPercentage = percentageElement ? percentageElement.innerHTML.trim() : '';
          const discountPriceElement = item.querySelector('.product-price__price');
          const tooltip = discountPriceElement ? discountPriceElement.getAttribute('data-tooltip') : '';
          const tooltipContent = item.querySelector('.rc_popup__how_it_works p');

          if (!tooltipContent) return;

          if (discountPercentage === '') {
            tooltipContent.innerText = tooltip;
          } else {
            tooltipContent.innerText =
              discountPercentage === '5%' || discountPercentage === '10%'
                ? `${discountPercentage} off and FREE shipping on all US subscription orders. Change or cancel anytime.`
                : `Save ${discountPercentage} on your first order, then 10% off + FREE U.S. shipping on every order. Cancel or change anytime.`;
          }
        });
      }, 1000);

      //yotpoWidgetsContainer.initWidgets();

      // ------------------------
      if (document.getElementById('data-review-product-stamped')?.dataset.reviews) {
        const dataReview = JSON.parse(document.getElementById('data-review-product-stamped')?.dataset.reviews);
        const productNew = Array.from(this.containerElement.children).slice(-9);
        productNew.forEach((e) => {
          let id = e.querySelector('.stamped-product-reviews-badge').dataset.id;
          let review = dataReview.find((e) => e.id == id)?.review;
          e.querySelector('.stamped-product-reviews-badge').innerHTML = review;
        });
      }
    }
  }.bind(this);
  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndReturnThis() {
  // This method is used to unbind event listeners from the DOM
  // This function is called manually to destroy "this" Ajaxinate instance
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };
  destroyers[this.settings.method]();
  return this;
};
